<!-- 图片 -->
<template>
    <div>
        <img :src="img" alt="">
    </div>
</template>

<script>
import { ref, reactive, getCurrentInstance } from 'vue'
export default {
    setup() {
        const { proxy } = getCurrentInstance();
        const params = proxy.getHashParam('appinfoImg')
        const imgMap = {
            'kefu': require('../../assets/appinfoImg/kefu.png'),
            'zhaoshang': require('../../assets/appinfoImg/zhaoshang.png'),
            'moshishuoming': require('../../assets/appinfoImg/moshishuoming.jpeg')
        }

        const titleMap = {
            'kefu': '在线客服',
        }

        const img = imgMap[params];
        console.log(img)

        document.title = titleMap[params];

        return {
            imgMap,
            img,
        }
    }
}

</script>
<style scoped>
img{
    width: 100%;
    display: inline-block;
}
</style>